import { PageHeader } from '../../../app/shell.js';
import { SettingsForm } from './SettingsForm.js';

export function GeneralSettingsPage() {
  return (
    <>
      <PageHeader title="General & company" />
      <main className="p-7">
        <SettingsForm
          namespace="general"
          fields={[
            { key: 'companyName', label: 'Company name', type: 'text' },
            { key: 'defaultCurrency', label: 'Default currency', type: 'text', help: '3-letter ISO code, e.g. USD' },
            { key: 'fiscalYearStartMonth', label: 'Fiscal year starts (month)', type: 'number' },
            { key: 'timeZone', label: 'Time zone', type: 'text' },
          ]}
        />
      </main>
    </>
  );
}
